"use client";

import type { UseRequestQueryProps } from "../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyCommunitiesAdminCommunities } from "./keyCommunitiesAdminCommunities";
import { requestCommunitiesAdminCommunitiesProps } from "./requestCommunitiesAdminCommunities";

export type UseRequestCommunitiesAdminCommunitiesProps = UseRequestQueryProps;

export const useRequestCommunitiesAdminCommunities = ({
  ...props
}: UseRequestCommunitiesAdminCommunitiesProps = {}) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: requestCommunitiesAdminCommunitiesProps,
    queryKey: keyCommunitiesAdminCommunities(),
  }),
});
